
fx.ns("shared.stage", class PrintArea extends shared.stage.Area {
    
	constructor(page, model, parentContainer, preview)
	{
        super(page, model, parentContainer, "", preview);
   }
  
  /***************** Actions *****************/
  
  get print()
  {
    return this.element;
  }

  get single()
  {
      return true;
  }

  _increasePrint()
  {
    this.print.quantity++;
  }

  _decreasePrint()
  {
    if(this.print.quantity>1){
      this.print.quantity--;
    }
  }

  _removePrint()
  {
    this.data.event("remove-creation", this.print);
  }

  _updateTexts()
  {
      if (this.printNbText)
          this.printNbText.text = fx.text("Tirage $", this.print.number+1);
  }

  _updatePrintsNumber()
  {
    if (this.print.quantity <= 1)
    {
      this.removePrintButton.show();
      this.decreasePrintButton.hide();
    }
    else
    {
      this.removePrintButton.hide();
      this.decreasePrintButton.show();
    }
    if (this.printNumber)
      this.printNumber.text = this.print.quantity;
  }

  /***************** Overrides *****************/

  onReady()
  {
    super.onReady();

    this.on("click", this._increasePrint,this.increasePrintButton);
    this.on("click", this._decreasePrint,this.decreasePrintButton);
    this.on("click", this._removePrint, this.removePrintButton);
  }

  create()
  {
    super.create();
      
    // Bottom labels and buttons (delete / add prints)
   
    this.printNbText = new fx.components.Text({text: fx.text("Tirage $", this.print.number+1) , className:"label"});
    this.addChild(this.printNbText, {left:-7, width:"auto", height:18, top: -20});

    this.bottomButtons = new fx.components.Box("bottomButtons");

    this.removePrintButton = new fx.components.IconButton({className : "action removePrintButton", icon : fx.assets.removeIcon});
    this.removePrintButton.effect = "fade";
    this.bottomButtons.addChild(this.removePrintButton, {height:40, width:40, left : 0});

    this.decreasePrintButton = new fx.components.IconButton({className : "action decreasePrintButton", icon : fx.assets.minusBtn});
    this.decreasePrintButton.visibleAtStart = false;
    this.bottomButtons.addChild(this.decreasePrintButton, {height:40, width:40, left : 0});

    this.printNumber = new fx.components.Text({text: this.print.quantity, className:"label printNumber"});
    this.bottomButtons.addChild(this.printNumber, {height:40, width:40, left : 30});

    this.increasePrintButton = new fx.components.IconButton({className : "action increasePrintButton", icon : fx.assets.plusBtn});
    this.bottomButtons.addChild(this.increasePrintButton, {height:40, width:40, left : 60});

    this.addChild(this.bottomButtons, {bottom: -50, left: 70, width: 97, height: 40});
  }

  refresh()
  {
    super.refresh();

    this._updateButtons();
  }
  /***************** Events *****************/

  onDataUpdated(action)
  {
      super.onDataUpdated(action);

      if (action.impacts("number"))
        this._updateTexts();
    else
    if (action.impacts("quantity"))
        this._updatePrintsNumber();
 }


 _updateButtons()
 {
    this.bottomButtons.css("transform", "scale(" + (1/this.scale) + ")");
    this.printNbText.css("transform", "scale(" + (1/this.scale) + ")");
    this.bottomButtons.left( (this.model.creation.pageWidth)/2-(this.bottomButtons.width() / 2 /this.scale) );
 }
});